@if (isLoading) {
  <div class="loader"></div>
}
@if (errorMessage) {
  <p>{{ errorMessage }}</p>
}
